module.exports = __webpack_public_path__ + "img/4.cd94ee23.jpg";